"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
exports.__esModule = true;
exports.EditableAreaBuilder = exports.EditableArea = exports.EditableSideBuilder = exports.EditableSide = exports.ShapeBuilder = exports.Shape = exports.EngravingType = exports.StonesPlacementType = exports.PlatingType = exports.StoneType = exports.MaterialType = exports.GeometryType = exports.Side = void 0;
var core_common_domain_1 = require("@jewelutions/core-common-domain");
var Side;
(function (Side) {
    Side["FRONT"] = "FRONT";
    Side["BACK"] = "BACK";
})(Side = exports.Side || (exports.Side = {}));
var GeometryType;
(function (GeometryType) {
    GeometryType["CROSS"] = "CROSS";
    GeometryType["HALF_MOON"] = "HALF_MOON";
    GeometryType["HEART"] = "HEART";
    GeometryType["OVAL"] = "OVAL";
    GeometryType["ROUND"] = "ROUND";
    GeometryType["RECTANGULAR"] = "RECTANGULAR";
    GeometryType["SQUARE"] = "SQUARE";
    GeometryType["STAR_FIVE"] = "STAR_FIVE";
    GeometryType["SUN"] = "SUN";
    GeometryType["TEARDROP"] = "TEARDROP";
    GeometryType["TRIANGLE"] = "TRIANGLE";
    GeometryType["OTHER"] = "OTHER";
})(GeometryType = exports.GeometryType || (exports.GeometryType = {}));
var MaterialType;
(function (MaterialType) {
    MaterialType["SILVER"] = "SILVER";
})(MaterialType = exports.MaterialType || (exports.MaterialType = {}));
var StoneType;
(function (StoneType) {
    StoneType["ZIRKONIUM"] = "ZIRKONIUM";
})(StoneType = exports.StoneType || (exports.StoneType = {}));
var PlatingType;
(function (PlatingType) {
    PlatingType["RHODIUM"] = "RHODIUM";
    PlatingType["YELLOW_GOLD"] = "YELLOW_GOLD";
    PlatingType["ROSE_GOLD"] = "ROSE_GOLD";
})(PlatingType = exports.PlatingType || (exports.PlatingType = {}));
var StonesPlacementType;
(function (StonesPlacementType) {
    StonesPlacementType["NO_STONES"] = "NO_STONES";
    StonesPlacementType["FULL_STONES"] = "FULL_STONES";
})(StonesPlacementType = exports.StonesPlacementType || (exports.StonesPlacementType = {}));
var EngravingType;
(function (EngravingType) {
    EngravingType["SYMBOL"] = "SYMBOL";
    EngravingType["SINGLE_LETTER"] = "SINGLE_LETTER";
    EngravingType["TEXT"] = "TEXT";
    EngravingType["VECTOR"] = "VECTOR";
    EngravingType["BITMAP"] = "BITMAP";
    EngravingType["NONE"] = "NONE";
})(EngravingType = exports.EngravingType || (exports.EngravingType = {}));
var Shape = /** @class */ (function () {
    function Shape() {
    }
    Shape.withPolyShapeUrl = function (oldShape, newMediaUrl) {
        if (oldShape.polyShape === undefined) {
            throw new core_common_domain_1.Exception("The shape " + JSON.stringify(oldShape) + " is not a polyShape. Cannot set the media url " + newMediaUrl + " in non-existent poly shape.");
        }
        return __assign(__assign({}, oldShape), { polyShape: {
                mediaDefined: core_common_domain_1.Media.withUrl(oldShape.polyShape.mediaDefined, newMediaUrl)
            } });
    };
    Shape.isValidDefined = function (shape) {
        return ((shape.polyShape !== undefined && shape.polyShape.mediaDefined !== core_common_domain_1.Media.UNDEFINED) ||
            shape.ellipseShape !== undefined ||
            shape.rectangeShape !== undefined);
    };
    return Shape;
}());
exports.Shape = Shape;
var ShapeBuilder = /** @class */ (function () {
    function ShapeBuilder(shape) {
        this.shape = shape;
    }
    ShapeBuilder.initialise = function () {
        return ShapeBuilder.initialiseWithPolyShapeMedia(core_common_domain_1.Media.UNDEFINED);
    };
    ShapeBuilder.initialiseWithPolyShapeMedia = function (media) {
        return new ShapeBuilder({
            polyShape: {
                mediaDefined: media
            }
        });
    };
    ShapeBuilder.prototype.build = function () {
        return this.shape;
    };
    return ShapeBuilder;
}());
exports.ShapeBuilder = ShapeBuilder;
var EditableSide = /** @class */ (function () {
    function EditableSide() {
    }
    EditableSide.withPolyShapeUrl = function (oldEditableSide, newMediaUrl) {
        return __assign(__assign({}, oldEditableSide), { shape: Shape.withPolyShapeUrl(oldEditableSide.shape, newMediaUrl) });
    };
    return EditableSide;
}());
exports.EditableSide = EditableSide;
var EditableSideBuilder = /** @class */ (function () {
    function EditableSideBuilder(editableSide) {
        this.editableSide = editableSide;
    }
    EditableSideBuilder.initialise = function (side, polyShapeMedia) {
        return new EditableSideBuilder({
            side: side,
            shape: ShapeBuilder.initialiseWithPolyShapeMedia(polyShapeMedia).build()
        });
    };
    EditableSideBuilder.prototype.build = function () {
        return this.editableSide;
    };
    return EditableSideBuilder;
}());
exports.EditableSideBuilder = EditableSideBuilder;
var EditableArea = /** @class */ (function () {
    function EditableArea() {
    }
    EditableArea.withPolyShapeUrl = function (oldEditableArea, newMediaUrl) {
        return __assign(__assign({}, oldEditableArea), { shape: Shape.withPolyShapeUrl(oldEditableArea.shape, newMediaUrl) });
    };
    return EditableArea;
}());
exports.EditableArea = EditableArea;
var EditableAreaBuilder = /** @class */ (function () {
    function EditableAreaBuilder(editableArea) {
        this.editableArea = editableArea;
    }
    EditableAreaBuilder.initialise = function (editableAreaId, polyShapeMedia, side, outlineCenter, engravingCenter, surfaceNormal) {
        return new EditableAreaBuilder({
            id: editableAreaId,
            side: side,
            shape: ShapeBuilder.initialiseWithPolyShapeMedia(polyShapeMedia).build(),
            engravingCenter: engravingCenter,
            outlineCenter: outlineCenter,
            surfaceNormal: surfaceNormal
        });
    };
    EditableAreaBuilder.prototype.build = function () {
        return this.editableArea;
    };
    return EditableAreaBuilder;
}());
exports.EditableAreaBuilder = EditableAreaBuilder;
